/** Live routes (IA §2 Operate › Live). Every view's state is in the URL (RULES §UI-3). */
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { appRoute } from '@/app/appRoute';
import { str } from '@/lib/search';

export interface LiveSearch {
  q?: string;
  /** State filter: driving,idling,… */
  state?: string;
  groups?: string;
  /** The unit in focus (one of the two). */
  vehicle?: string;
  asset?: string;
  /** Which list is shown beside the map. */
  list?: 'vehicles' | 'assets';
  /** Phones: map or list. */
  view?: 'map' | 'list';
  /** Geofences drawn on the map. */
  places?: '1';
  /** Assets hidden from the map. */
  assets?: '0';
  /** Only these vehicles (the assistant's "show on map"). */
  only?: string;
}

export const liveRoute = createRoute({
  getParentRoute: () => appRoute,
  path: '/live',
  staticData: { permission: 'live.vehicle.read' },
  validateSearch: (s: Record<string, unknown>): LiveSearch => ({
    q: str(s.q),
    state: str(s.state),
    groups: str(s.groups),
    vehicle: str(s.vehicle),
    asset: str(s.asset),
    list: s.list === 'assets' ? 'assets' : undefined,
    view: s.view === 'list' ? 'list' : undefined,
    places: s.places === '1' || s.places === 1 ? '1' : undefined,
    assets: s.assets === '0' || s.assets === 0 ? '0' : undefined,
    only: str(s.only),
  }),
  component: lazyRouteComponent(() => import('./LivePage')),
});

export interface ReplaySearch {
  vehicle?: string;
  asset?: string;
  /** Window as ISO instants (default: today so far). */
  start?: string;
  end?: string;
  /** Cursor, epoch seconds. */
  at?: number;
}

const isoOrUndefined = (v: unknown): string | undefined => {
  const s = str(v);
  return s && !Number.isNaN(Date.parse(s)) ? s : undefined;
};

export const replayRoute = createRoute({
  getParentRoute: () => appRoute,
  path: '/live/replay',
  staticData: { permission: ['trips.trip.read', 'places.asset.read'] },
  validateSearch: (s: Record<string, unknown>): ReplaySearch => ({
    vehicle: str(s.vehicle),
    asset: str(s.asset),
    start: isoOrUndefined(s.start),
    end: isoOrUndefined(s.end),
    at: typeof s.at === 'number' && Number.isFinite(s.at) ? s.at : typeof s.at === 'string' && /^\d+(\.\d+)?$/.test(s.at) ? Number(s.at) : undefined,
  }),
  component: lazyRouteComponent(() => import('./replay/ReplayPage')),
});
